// extracted by css-extract-rspack-plugin
export default {"badge":"yqcnd","button":"mODpM"};